import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AmpVideoConfig } from '@medscape/streaming-video-player';

class VideoSchema extends Component {
    constructor(props) {
        super(props);
        //console.log("[VideoSchema] props:",props);
    }

    get JSON() {

        let { video, imageServer, summary, publishDate, thumbnail } = this.props
        let { duration, title } = video;
        
        // Remove HTML tags from the data
        let textDiv = document.createElement('div');

        textDiv.innerHTML = title;
        title = textDiv.innerText;

        textDiv.innerHTML = summary;
        summary = textDiv.innerText;

        let d = duration.split(":");

        if (d.length > 2) {
            duration = `PT${d[0]}H${d[1]}M${d[2]}S`;
        } else if (d.length == 2) {
            duration = `PT${d[0]}M${d[1]}S`;
        } else {
            duration = `PT${d[0]}S`;
        }

        let uploadDate = (new Date(publishDate.date)).toISOString();

        let ampConfig = new AmpVideoConfig(video);
        let source = 'https:' + ampConfig.media.source[0].src;
        let JSON = {
            "@context": "https://schema.org",
            "@type": "VideoObject",
            "name": title,
            "description": summary,
            "thumbnailUrl": `https:${imageServer.host}${thumbnail}`,
            "uploadDate": uploadDate,
            "duration": duration,
            "contentUrl": source,
            "embedUrl": `https://${document.location.host}${document.location.pathname}`
        }

        return JSON;

    }
    componentDidUpdate(prevProps) {
        //console.log("[VideoSchema] Updated:",this.props);
    }
    render() {
        return (
            <script type="application/ld+json">
                { JSON.stringify(this.JSON) }
            </script>
        );
    }

    static get propTypes() {
        return {
            video: PropTypes.object,
            location: PropTypes.object,
            imageServer: PropTypes.object,
            summary: PropTypes.string,
            thumbnail: PropTypes.string,
            publishDate: PropTypes.object
        }
    }

    static get defaultProps() {
        return {
            video: null,
            location: null,
            imageServer: null,
            summary: "",
            thumbnail: ""
        }
    }
}



export default VideoSchema;